/**
 * @generated SignedSource<<0b9dc970f085e78a71b98aca0ceb4139>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SavingsPlanFrequency = "BIWEEKLY" | "DAILY" | "MONTHLY" | "WEEKLY";
export type CreateSavingsPlanInput = {
  amount: string;
  assetId: string;
  date: DateScalar;
  frequency?: SavingsPlanFrequency | null | undefined;
};
export type CreateSavingsPlanMutation$variables = {
  input?: CreateSavingsPlanInput | null | undefined;
};
export type CreateSavingsPlanMutation$data = {
  readonly createSavingsPlan: {
    readonly __typename: "SavingsPlan";
    readonly id: string;
  } | {
    readonly __typename: "SavingsPlanSignatureNeeded";
    readonly deepLink: string;
    readonly savingsPlan: {
      readonly id: string;
    } | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type CreateSavingsPlanMutation = {
  response: CreateSavingsPlanMutation$data;
  variables: CreateSavingsPlanMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deepLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SavingsPlan",
      "kind": "LinkedField",
      "name": "savingsPlan",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "type": "SavingsPlanSignatureNeeded",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "SavingsPlan",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSavingsPlanMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createSavingsPlan",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSavingsPlanMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createSavingsPlan",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b235beb16a4848f99b47dcd850a8b8bd",
    "id": null,
    "metadata": {},
    "name": "CreateSavingsPlanMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSavingsPlanMutation(\n  $input: CreateSavingsPlanInput\n) {\n  createSavingsPlan(input: $input) {\n    __typename\n    ... on SavingsPlanSignatureNeeded {\n      deepLink\n      savingsPlan {\n        id\n      }\n    }\n    ... on SavingsPlan {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2bfe7a9a729b750a13a463c7138d25f5";

export default node;
